import {$http} from '@/utils/https'
import {
    CHANGE_CATEGORY,
    CHANGE_HEADER,
    CHANGE_LIST_LOADING,
    CHANGE_LOADING,
    CHANGE_LOADING_REPORT,
    CHANGE_LOADING_TEST,
    CHANGE_POPUP_CANCEL_TEST,
    CHANGE_SKIP,
    CHANGE_STEP,
    SET_CURRENT_QUESTION,
    SET_ITEM,
    SET_LIST,
    SET_LIST_LENGTH,
    SET_REPORT_RESULT,
} from '../mutation-types';

import {
    ATTACH_TESTS,
    COMPLETE_QUESTION,
    COMPLETE_TEST,
    GET_LIST,
    GET_LIST_ITEM,
    GET_REPORT,
    START_TEST
} from '../action-types';


const state = {
    list: [],
    isListLoading: false,
    listLength: 0,
    skip: 0,
    limit: 9,

    activeStep: 0,
    currentItem: null,
    isLoading: false,
    isLoadingTest: false,
    isLoadingReport: false,
    reportResult: null,

    activeCategory: '',
    currentTest: null,
    showPopupCancel: false,

    header: {
        show: false,
        title: '',
        currentTime: '',
        availableTime: '',
        parentRoute: ''
    },
};

const getters = {
    list: state => state.list,
    listLength: state => state.listLength,
    skip: state => state.skip,
    limit: state => state.limit,
    isListLoading: state => state.isListLoading,
    currentItem: state => state.currentItem,
    activeStep: state => state.activeStep,
    header: state => state.header,
    activeCategory: state => state.activeCategory,
    isLoading: state => state.isLoading,
    currentTest: state => state.currentTest,
    isLoadingTest: state => state.isLoadingTest,
    isLoadingReport: state => state.isLoadingReport,
    reportResult: state => state.reportResult,
    showPopupCancel: state => state.showPopupCancel,
};

const actions = {
    [GET_LIST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LIST_LOADING, true);
            if (payload.isResetList) {
                commit(SET_LIST, []);
                commit(CHANGE_SKIP, true)
            } else commit(CHANGE_SKIP);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}tests?include=category,picture,picture.seo,userTest,authors&filters[categories]=${state.activeCategory}&skip=${state.skip}&limit=${state.limit}`);
            payload.isResetList && commit(SET_LIST, []);

            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LIST_LOADING, false);
        }
    },
    [GET_LIST_ITEM]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}tests/${payload.testId}?include=seo,userTest&use_as_id=slug`);
            commit(SET_ITEM, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
    [START_TEST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_TEST, true);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_EDUCATION}user/tests/${payload.testId}/start`);
            commit(SET_CURRENT_QUESTION, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_TEST, false);
        }
    },
    [COMPLETE_QUESTION]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_TEST, true);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_EDUCATION}user/tests/${payload.get('testId')}/questions/${payload.get('id')}/complete`, payload);
            commit(SET_CURRENT_QUESTION, response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_TEST, false);
        }
    },
    [COMPLETE_TEST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_TEST, true);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_EDUCATION}user/tests/${payload.get('testId')}/complete`, payload);
            commit(SET_CURRENT_QUESTION, response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_TEST, false);
        }
    },
    [GET_REPORT]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_REPORT, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}user/tests/${payload.testId}/report?include=&use_as_id=slug`, payload);
            commit(SET_REPORT_RESULT, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_REPORT, false);
        }
    },
    [ATTACH_TESTS]: async ({commit}, payload) => {
        try {
            return await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}user/tests/${payload.testId}/report`, payload);
        } catch (e) {
            throw e;
        }
    },
};

const mutations = {
    [SET_LIST](state, data) {
        if (!data.length) {
            state.list = data;
        } else {
            data.map(e => {
                if (e.hasOwnProperty('authors')) {
                    e.speakers = e.authors
                }
                return e
            });
        }
        !state.list.length ? state.list = data : state.list.push(...data);
    },
    [SET_ITEM](state, data) {
        state.currentItem = data;
    },
    [CHANGE_LIST_LOADING](state, status) {
        state.isListLoading = status;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoading = status;
    },
    [CHANGE_LOADING_REPORT](state, status) {
        state.isLoadingReport = status;
    },
    [SET_REPORT_RESULT](state, data) {
        state.reportResult = data;
    },
    [CHANGE_STEP](state, number) {
        state.activeStep = number;
    },
    [CHANGE_LOADING_TEST](state, status) {
        state.isLoadingTest = status;
    },
    [CHANGE_HEADER](state, params) {
        state.header = params
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [CHANGE_SKIP](state, status = false) {
        if (status) {
            state.skip = 0
        } else state.skip += state.limit;
    },
    [SET_CURRENT_QUESTION](state, data) {
        state.currentTest = data;
    },
    [CHANGE_POPUP_CANCEL_TEST](state, status) {
        state.showPopupCancel = status;
    },
    [CHANGE_CATEGORY](state, category = '') {
        state.activeCategory = category;
        state.skip = 0;
        state.listLength = 0;
        state.list = [];
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
